module.exports = __webpack_public_path__ + "static/media/icon-coletados.c830ebf2.svg";